import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf3d22a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "iodine-padding-bottom-md iodine-padding-top-md"
}

import EditsSectionContainer from 'components/resources/edits/EditsSectionContainer.vue';
import { useGrouperStore } from 'stores/GrouperStore';
import { onMounted, ref } from 'vue';
import { EditData } from 'src/contracts/edit';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditsPane',
  setup(__props) {

const sections = [
  {display: 'Medicare Code Edits (MCE)', value: 'MCE'},
  {display: 'TruCode Edits', value: 'TruCode'},
  {display: 'Validation Edits', value: 'Validation'},
  {display: 'RAC', value: 'RAC'},
  {display: 'MNE', value: 'MNE'}
];

const edits = ref<EditData[]>([]);

onMounted(async () => {
    await useGrouperStore().calculateDrg(true, false);
    useGrouperStore().procedureCodes?.forEach(x => {
        if (x.edit) {
            edits.value.push(x.edit);
        }
    });
    useGrouperStore().diagnosisCodes?.forEach(x => {
        if (x.edit) {
            edits.value.push(x.edit);
        }
    });
})
function getItems(section: string): EditData[] {
  return edits.value?.filter(x => x.type === section);
}

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!

  return (_openBlock(), _createBlock(_component_q_scroll_area, { class: "research-scroll-area" }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (section, index) => {
        return _createElementVNode("div", { key: section }, [
          (index !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_q_separator)
              ]))
            : _createCommentVNode("", true),
          _createVNode(EditsSectionContainer, {
            "section-name": section.display,
            items: getItems(section.value)
          }, null, 8, ["section-name", "items"])
        ])
      }), 64))
    ]),
    _: 1
  }))
}
}

})